import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/logo.png"
                alt="Koctech Logo"
                className="h-12 w-auto object-contain brightness-0 invert"
                style={{ maxHeight: '48px' }}
              />
              <div>
                <span className="font-bold text-lg">Koctech</span>
                <span className="block text-sm text-teal-400">İklimlendirme</span>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed font-normal">
              Profesyonel iklimlendirme çözümleri ile konforunuz için yanınızdayız.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-teal-400">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 text-sm">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 text-sm">
                  Ürünler
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 text-sm">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 text-sm">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/ai-recommendation" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 text-sm">
                  Klima Önerisi
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-teal-400">Hizmetlerimiz</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="hover:text-teal-400 transition-colors duration-300 cursor-pointer">Klima Montajı</li>
              <li className="hover:text-teal-400 transition-colors duration-300 cursor-pointer">VRF Sistemleri</li>
              <li className="hover:text-teal-400 transition-colors duration-300 cursor-pointer">Teknik Servis</li>
              <li className="hover:text-teal-400 transition-colors duration-300 cursor-pointer">Bakım & Onarım</li>
              <li className="hover:text-teal-400 transition-colors duration-300 cursor-pointer">7/24 Destek</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-teal-400">İletişim</h3>
            <div className="space-y-3">
              <a href="tel:05516380934" className="flex items-start space-x-3 text-gray-400 hover:text-teal-400 transition-colors duration-300 group">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" />
                <span className="text-sm">0551 638 09 34</span>
              </a>
              <a href="mailto:koctechiklimlendirme@gmail.com" className="flex items-start space-x-3 text-gray-400 hover:text-teal-400 transition-colors duration-300 group">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" />
                <span className="text-sm break-all">koctechiklimlendirme@gmail.com</span>
              </a>
              <div className="flex items-start space-x-3 text-gray-400">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span className="text-sm">Turgut Özal Mahallesi 2141 Cadde No:4-9 Dükkan 12</span>
              </div>
              <a href="https://instagram.com/koctechiklimlendirme" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-gray-400 hover:text-teal-400 transition-colors duration-300 group">
                <Instagram className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" />
                <span className="text-sm">@koctechiklimlendirme</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="text-center mb-4">
            <p className="text-2xl font-bold bg-gradient-to-r from-teal-400 to-teal-200 bg-clip-text text-transparent mb-2">
              Koctech Klima – Doğanın Dengesi, Evinizin Konforu
            </p>
          </div>
          <p className="text-gray-400 text-sm text-center">
            © 2025 Koctech İklimlendirme. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;